/*
 * @Description: 说明
 * @version: 版本
 * @Author: 作者
 * @Date: 2022-07-14 19:47:48
 * @LastEditTime: 2022-08-09 16:10:24
 */
export default {
    //7.6.2 商家落地页
    //查询落地页tab
    queryLandPageById: "/zuul/yuanyaotech-cloud-service-activity/wap/businessLandingPage/queryLandPageById",
    //根据tabid和品类查询报价
    queryQuotationByConfig: "/zuul/yuanyaotech-cloud-service-activity/wap/businessLandingPage/queryQuotationByConfig",
    
    //7.6.6.8 动态页面
    queryDynamicPageById: "/zuul/yuanyaotech-cloud-service-activity/wap/dynamicPage/queryDynamicPageById",
    //微信分享获取appid相关信息
    weiXinForIm: '/zuul/yuanyaotech-wap/rest/api/v1/wxShare/weiXinForIm',

    // 分享获取文案图标 release_hot-fix_v8.6
    queryShareContent: '/zuul/yuanyaotech-wap/rest/api/v1/wxShare/queryShareContent', 

    // v7.9.3.13 渠道码统计
    spreadChanneladdHitsRecord: '/zuul/yuanyaotech-cloud-service-statistics/wap/spreadChannel/addHitsRecord',
}


// WEBPACK FOOTER //
// ./src/api/index.js